import React, { Component } from 'react';
import { Portal } from 'react-portal';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  SR_API_ACTION_UPDATE_MOVE_IN_DATE,
} from 'api/actionTypes';

import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';
import SrFormikField from 'client/components/SrFormikField';
import { createFormValidationFn } from 'client/helpers/formikHelpers';
import withApiState from 'client/helpers/withApiState';
import UserActions from 'client/actions/User';

const formFields = [
  {
    id: 'moveInDate',
    type: 'date_input',
    properties: {
      placeholder: 'MM/DD/YYYY',
    },
    validations: ['required', 'date', 'noPastDates'],
  },
];

@withApiState({
  updateMoveInDateApiState: {
    action: SR_API_ACTION_UPDATE_MOVE_IN_DATE,
  },
})
class SrUpdateMoveInDateModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    updateMoveInDateApiState: PropTypes.object.isRequired,
    updateMoveInDateModalOpen: PropTypes.bool.isRequired,
    forceMoveInDateUpdate: PropTypes.bool.isRequired,
  }

  _onUpdateMoveInDate = (values) => {
    const { dispatch } = this.props;
    dispatch(UserActions.updateMoveInDate, {
      moveInDate: values.moveInDate,
    }).then(() => {
      this._onClose();
    });
  }

  _onClose = () => {
    const { dispatch } = this.props;
    dispatch(UserActions.setUpdateMoveInDateModalOpen, false);
  }

  render() {
    const {
      updateMoveInDateApiState,
      updateMoveInDateModalOpen,
      forceMoveInDateUpdate,
    } = this.props;

    if (!updateMoveInDateModalOpen) {
      return null;
    }

    return (
      <Portal>
        <div className='updateMoveInDateModal'>
          <div
            className='backdrop'
            onClick={forceMoveInDateUpdate ? null : this._onClose}
          >
            <div className='contentContainer'>
              <div className='actionsContainer'>
                <Formik
                  enableReinitialize
                  validateOnChange
                  validate={createFormValidationFn(formFields)}
                  onSubmit={this._onUpdateMoveInDate}
                  render={(formikBag) => {
                    return (
                      <div onClick={(evt) => evt.stopPropagation()}>
                        <Form className='form updateMoveInDateForm'>
                          <img className='heroIcon' alt='Home' src='/images/farMoveIn.jpg' />
                          <span className='headline'>When are you moving?</span>
                          <span className='description'>
                            Find homes that are available around the date you plan on moving!
                          </span>
                          {formFields.map((formField) => (
                            <SrFormikField
                              key={formField.id}
                              formField={formField}
                              formikBag={formikBag}
                            />
                          ))}
                          {updateMoveInDateApiState.error && (
                            <div style={{ color: 'red' }}>
                              {updateMoveInDateApiState.error.message}
                            </div>
                          )}
                          <div className='bottomActions'>
                            <ButtonDeprecated
                              theme={BUTTON_THEME_BLUE}
                              onClick={formikBag.handleSubmit}
                              disabled={!formikBag.isValid || updateMoveInDateApiState.inProgress}
                            >
                              {updateMoveInDateApiState.inProgress ? 'saving...' : 'save date'}
                            </ButtonDeprecated>
                          </div>
                        </Form>
                      </div>
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </Portal>
    );
  }
}

SrUpdateMoveInDateModal.displayName = 'SrUpdateMoveInDateModal';

export default SrUpdateMoveInDateModal;
